/** The creator workshop is available only after a backend-verified account session. */
export function canOpenCreatorWorkspace(role: string | undefined, mode: string | undefined): boolean {
  return (role === "creator" || role === "admin") && (mode === "account" || mode === "apple");
}
